import React, { useContext, useState } from "react";
import { AppContext } from "../../context";

const AHPButtonOptions = ({ options, setSelectedService, width = "auto" }) => {
  const [pressed, setPressed] = useState(null);
  const info = useContext(AppContext);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      {options.map((option, index) => (
        <div
          className="ahp-button-option"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            backgroundColor: index === pressed ? "#BBB2C4" : "white",
            color: index === pressed ? "white" : "black",
            width,
          }}
          key={index}
          onClick={() => {
            setSelectedService(option.name);
            setPressed(index);
          }}
        >
          {option.icon}
          <div>{info.t(option.name)}</div>
        </div>
      ))}
    </div>
  );
};

export default AHPButtonOptions;
